import { FieldOptionTooltipProps } from './field';

import styles from './select-options.module.scss';

export const FieldOptionTooltip = (props: FieldOptionTooltipProps) => {
  const { field } = props;
  return (
    <aside className={styles.optionTooltip}>
      <strong className={styles.header}>
        {field.name} <span className={styles.type}>{field.type ?? ''}</span>
      </strong>
      {field.model !== undefined && (
        <p>
          <strong>Model:</strong> {field.model?.name}
        </p>
      )}
      {field.description !== undefined && <p>{field.description}</p>}
    </aside>
  );
};
